import Environment from '@interfaces/environment.interface'
import QuestionGroupedInterface, { AnswersFormated, AnswersPayload } from '@interfaces/questions.interface'
import onEnvironmentChange from '@observables/environment.observable'
import LogService from '@services/log/log.service'
import MainService from '@services/main/main.service'
import { AxiosResponse } from 'axios'
import { take } from 'rxjs/operators'

export default class IBGEService extends MainService {
  url: string
  logService = new LogService()

  constructor(ibgeUrl?: string) {
    super()
    if (!ibgeUrl) {
      onEnvironmentChange.pipe(take(1)).subscribe((environment: Environment) => {
        this.url = environment?.squidApis?.ibge
      })
    } else {
      this.url = ibgeUrl
    }
    this.logService.init('IBGE Service')
  }

  async getQuestions(active = 1, excludeTypes = []): Promise<Array<QuestionGroupedInterface>> {
    excludeTypes = excludeTypes.map((type) => `&excludeTypes=${type}`)

    const headers = await this.getHeaders()
    return this.http
      .get(`${this.url}/hub/questions-all?active=${active}${excludeTypes}`, {
        headers,
      })
      .then((r: AxiosResponse) => r.data || {})
      .catch((error: any) => {
        this.logService.error({
          message: 'Error on get questions',
          error,
        })
        throw error.response
      })
  }

  async getAnswers(): Promise<AnswersFormated> {
    const headers = await this.getHeaders()

    return this.http
      .get(`${this.url}/hub/answers`, {
        headers,
      })
      .then((r: AxiosResponse) => r.data || {})
      .catch((error: any) => {
        this.logService.error({
          message: 'Error on get answers',
          error,
        })
        throw error.response
      })
  }

  async putAnswer(answers: AnswersPayload[]): Promise<Array<AnswersPayload>> {
    const headers = await this.getHeaders()

    return this.http
      .put(`${this.url}/hub/answers`, answers, {
        headers,
      })
      .then((r: AxiosResponse) => r.data || [])
      .catch((error: any) => {
        this.logService.error({
          message: 'Error on put answers',
          error,
        })
        throw error.response
      })
  }
}
